import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import { Container as Grid } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import Clickable from '../../components/Clickable'
import TopBar from '../TopBar'
import AutoFocus from '../AutoFocus'

import iconStyle from 'Styles/icon.css'
import style from './style.css'
import baseStyle from 'Styles/base.css'

import caretRight from 'Assets/caret-right-acqua.svg'
import caretDown from 'Assets/caret-down-acqua.svg'
import closeIconWhite from 'Assets/x-icon-white.svg'
import closeIconDark from 'Assets/x-icon-dark-gray.svg'
import backArrow from 'Assets/arrow-left.svg'

import { FAQ_DATA as faqData } from './questions'

function FaqItem (props) {
  return (
    <div className={style.faqRow}>
      {(() => {
        switch (props.index) {
          case 0:
            return <h3 className={style.faqRow}>Activity Completion, Grading, and Due Dates</h3>
          case 5:
            return <h3 className={style.faqRow}>Activity Questions</h3>
          case 8:
            return <h3 className={style.faqRow}>Feedback and Hints</h3>
          case 11:
            return <h3 className={style.faqRow}>Topic Scores and Personalized Study Plans</h3>
          default:
            return null
        }
      })()}
      <Clickable
        aria-expanded={props.isExpanded}
        data-test-id="faqQuestion"
        onClick={props.onClick}
      >
        {(() => {
          if (!props.browser.lessThan.medium) {
            if (props.isExpanded) {
              return <img aria-hidden="true" className={style.faqCaret} src={caretDown} alt="caret expanded" />
            } else {
              return <img aria-hidden="true" className={style.faqCaret} src={caretRight} alt="caret collapsed" />
            }
          }
        })()}
        <span className={style.question}>{props.question}</span>
      </Clickable>
      {props.isExpanded
        ? <p className={style.answer} data-test-id="faqAnswer" tabIndex="0">{props.answer}</p>
        : null
      }
    </div>
  )
}

FaqItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  browser: PropTypes.object
}

class FaqItemContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isExpanded: false
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.allExpanded !== this.props.allExpanded) {
      this.setState({
        isExpanded: nextProps.allExpanded
      })
    }
  }

  toggleFaqItem () {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render () {
    return (
      <FaqItem
        onClick={this.toggleFaqItem.bind(this)}
        isExpanded={this.state.isExpanded}
        {...this.props}
      />
    )
  }
}

FaqItemContainer.propTypes = {
  allExpanded: PropTypes.bool
}

export default class FaqPageQuestionContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      allExpanded: false
    }
  }

  toggleAllItems () {
    this.setState({ allExpanded: !this.state.allExpanded })
  }

  renderChildren (isAchieve) {
    const closeIcon = isAchieve ? closeIconDark : closeIconWhite
    const icon = this.props.browser.lessThan.medium ? backArrow : closeIcon
    if (isAchieve) {
      return ([
        <div className={classnames(style.pageTitle, style.achievePageTitle)} tabIndex="0">
          <span>About LearningCurve</span>
        </div>,
        <AutoFocus
          className={style.autoFocus}
        >
          <button
            data-test-id="backToStudyPlanBtn"
            aria-label="Close About Learning Curve"
            onClick={this.props.onClick}
            className={style.buttonContainer}
            tabIndex="0"
          >
            <object
              data={icon} type="image/svg+xml"
              className={classnames(iconStyle.svgIcon, style.closeIcon)}
              tabIndex="-1"
            />
          </button>
        </AutoFocus>
      ])
    }
    return ([
      <AutoFocus
        className={style.autoFocus}
      >
        <button
          data-test-id="backToStudyPlanBtn"
          aria-label="Close About Learning Curve"
          onClick={this.props.onClick}
          className={style.buttonContainer}
          tabIndex="0"
        >
          <object
            data={icon} type="image/svg+xml"
            className={classnames(iconStyle.svgIcon, style.closeIcon)}
            tabIndex="-1"
          />
        </button>
      </AutoFocus>,
      <div className={classnames(style.pageTitle)} tabIndex="0">
        <span>About LearningCurve</span>
      </div>
    ])
  }

  render () {
    window.scrollTo(0, 0)
    const { headerStyle } = this.props
    const isAchieve = headerStyle === 'achieve'
    return (
      <div className={classnames(style.container, baseStyle.pspPreviewTopBarSpace)}>

        {headerStyle !== 'hidden' &&
        <TopBar
          headerStyle={this.props.headerStyle}
          faqStyle={isAchieve}
        >
          {this.renderChildren(isAchieve)}
        </TopBar>}

        <Grid
          className={classnames(style.pageContainer,
            { [style.pageContainerMobile]: this.props.browser.lessThan.medium })}
          {...(this.props.headerStyle !== 'achieve' ? { role: 'main' } : {})}
        >
          <Row className={style.innerContent}>
            <Col sm={12}>
              {!this.props.browser.lessThan.medium
                ? <div>
                  <h2 className={style.faqTitle}>Student FAQ</h2>
                  <div className={style.faqToggleAll}>
                    <Clickable
                      data-test-id="faqShowAll"
                      onClick={this.toggleAllItems.bind(this)}
                    >
                      {this.state.allExpanded ? 'Collapse all' : 'Expand all'}
                    </Clickable>
                  </div>
                </div>
                : null}
              {
                _.map(faqData, (faqItem, index) =>
                  <FaqItemContainer
                    key={faqItem.question}
                    index={index} {...faqItem}
                    allExpanded={this.state.allExpanded}
                    browser={this.props.browser}
                  />
                )
              }
            </Col>
          </Row>
        </Grid>

      </div>
    )
  }
}

FaqPageQuestionContainer.propTypes = {
  onClick: PropTypes.func.isRequired,
  browser: PropTypes.object,
  headerStyle: PropTypes.string
}
